import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

const textHighlightVariants = cva(
  'rounded-sm px-1 py-px box-decoration-clone',
  {
    variants: {
      color: {
        blue: 'bg-highlight-blue',
        amber: 'bg-highlight-amber',
        green: 'bg-highlight-green',
        red: 'bg-highlight-red',
        yellow: 'bg-highlight-yellow',
        orange: 'bg-highlight-orange',
      },
    },
    defaultVariants: {
      color: 'blue',
    },
  }
)

type TextHighlightColor = NonNullable<
  VariantProps<typeof textHighlightVariants>['color']
>

function TextHighlight({
  className,
  color = 'blue',
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof textHighlightVariants>) {
  return (
    <span
      data-slot='text-highlight'
      data-color={color}
      className={cn(textHighlightVariants({ color }), className)}
      {...props}
    />
  )
}

export { TextHighlight, type TextHighlightColor, textHighlightVariants }
